export const SET_ZOOM_SCALE = 'STAGE/SET_ZOOM_SCALE';

export const SET_CURRENT_PIECE = 'STAGE/SET_CURRENT_PIECE';

export const UNSET_CURRENT_PIECE = 'STAGE/UNSET_CURRENT_PIECE';
